<template>
  <Layout>
    <div
      style="
        justify-content: center;
        align-items: center;
        display: flex;
        flex-direction: column;
      "
    >
      <div class="base-class">
        <div class="top-item" @click="goSearch('通用接龙')">
          <!-- <el-image
            class="top-image"
            :src="require('@/assets/images/home/tyjl-back.png')"
          ></el-image> -->
          <p class="top-title" > {{ appid == "wx7d8daf6d777947a2" ? "通用报名" : "通用接龙" }}</p>

          <div style="display: flex; justify-content: space-between">
            <div style="display: flex; margin-left: 15px">
              <p class="top-count">{{ isButler ? "接龙" : "报名" }}</p>
              <p class="top-count" style="margin-left: 10px">表单</p>
              <p class="top-count" style="margin-left: 10px">登记</p>
              <p class="top-count" style="margin-left: 10px">填表</p>
            </div>
            <div>
              <p class="creat-text">免费创建>></p>
            </div>
          </div>
        </div>
        <div class="top-item " @click="goSearch('签到打卡')" style="background:linear-gradient(to right,#317AF7,#84B0FE)">
          <!-- <el-image
            class="top-image"
            :src="require('@/assets/images/home/qddk-back.png')"
          ></el-image> -->
          <p class="top-title">签到打卡</p>
          <div style="display: flex; justify-content: space-between">
            <div style="display: flex; margin-left: 15px">
              <p class="top-count">周期性多次收集信息</p>
            </div>
            <div>
              <p class="creat-text">免费创建>></p>
            </div>
          </div>
        </div>
        <div class="top-item" @click="isButler ? goSearch('收费报名') : goSearch('预约')" style="background:linear-gradient(to right,#26C05F,#25E481)">
          <!-- <el-image
            class="top-image"
            :src="require('@/assets/images/home/qddk-back.png')"
          ></el-image> -->
          <p class="top-title">{{ isButler ? "收费报名" : "预约" }}</p>
          <div style="display: flex; justify-content: space-between">
            <div style="display: flex; margin-left: 15px">
              <p class="top-count">{{ isButler ? "在线收款、推荐返利" : "日期时段报名" }}</p>
            </div>
            <div>
              <p class="creat-text">免费创建>></p>
            </div>
          </div>
        </div>
        <!--<div class="top-item">
          <el-image
            class="top-image"
            :src="require('@/assets/images/home/jjqd-back.png')"
          ></el-image>
          <p class="top-title">敬请期待</p>
          <div style="display: flex; margin-left: 31px">
            <p class="top-count"></p>
          </div>
          <div>
            <p
              class="creat-text"
              style="
                margin-top: 21px;
                text-align: left;
                margin-left: 30px;
                font-weight: 300;
              "
            >
              新功能开发中.......
            </p>
          </div>
        </div> -->
      </div>

      <div class="base-class">
        <div
          class="click-item"
          v-for="topItem in clickItems"
          :key="topItem.id"
          @click="goSearch(topItem.titleStr)"
        >
          <el-image
            class="click-image"
            :src="require('@/assets/images/home/' + topItem.imageStr)"
          ></el-image>
          <div style="text-align: right">
            <p class="click-title">{{ topItem.titleStr }}</p>
            <p class="click-creat">免费创建>></p>
          </div>
        </div>
      </div>
      <div class="base-class">
        <div
          class="click-item"
          v-for="topItem in otherclickItems"
          :key="topItem.id"
          @click="goOtherWeb(topItem)"
        >
          <el-image
            class="click-image"
            :src="require('@/assets/images/bmgj/' + topItem.imageStr + '.png')"
          ></el-image>
          <div style="text-align: right">
            <p class="click-title">{{ topItem.titleStr }}</p>
            <p class="click-creat">免费创建>></p>
          </div>
        </div>
      </div>

      <div class="base-class" style="display: block">
        <div v-for="(item, index) in tableData" :key="index">
          <div class="model-top">
            <p class="model-top-title">{{ item.name }}</p>
            <p
              class="model-top-more"
              style="cursor: pointer"
              @click="lookMareClick(item.name)"
            >
              查看更多>>
            </p>
          </div>

          <div
            style="
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
            "
          >
            <div
              class="model-item"
              v-for="(sitem, index) in item.array"
              :key="index"
              @click="creatClick(sitem)"
            >
              <div style="display: flex; flex: 1">
                <el-image
                  class="click-image"
                  :src="imageUrl + sitem.cover_img"
                  style="
                    background-color: bisque;
                    margin: 11px;
                    border-radius: 3px;
                  "
                ></el-image>

                <div style="width: 220px">
                  <p class="model-item-title" :title="sitem.name">
                    {{ sitem.name }}
                  </p>
                  <p class="model-item-count">{{ sitem.auxiliarytitle }}</p>
                </div>
              </div>

              <i class="el-icon-arrow-right" style="margin-right: 11px"></i>
              <!--              <div class="free-button">免费使用</div>-->
            </div>
            <div
              v-for="n in emptyDivs[index]"
              :key="'empty-' + index + '-' + n"
              class="emptyDiv"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { getHomePageTempleList } from "@/utils/api/activity";
import { imageUrl } from "@/utils/config/commonUrl.js";
import copyrightConfig from "@/utils/config/changeCopyright.js";
const appid = copyrightConfig.AppID;
export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
    title: "发布项目",
  },
  components: { Layout },
  data() {
    return {
      imageUrl: imageUrl,
      isButler: appid == "wx7d8daf6d777947a2",
      appid: copyrightConfig.AppID,
      clickItems: [
        {
          imageStr: "hdbm.png",
          titleStr: "活动报名",
          id: 21,
        },
        {
          imageStr: "sfbm.png",
          titleStr: "收费报名",
          id: 22,
        },
        {
          imageStr: "dkjl.png",
          titleStr: "打卡接龙",
          id: 23,
        },
        {
          imageStr: "qdjl.png",
          titleStr: "签到接龙",
          id: 24,
        },
        {
          imageStr: "xxsj.png",
          titleStr: "信息收集",
          id: 25,
        },
      ],
      otherclickItems: [
        {
          imageStr: "tp",
          titleStr: "发起投票",
          url: "https://www.tpguanjia.com/",
        },
        {
          imageStr: "px",
          titleStr: "活动评选",
          url: "https://www.tpguanjia.com/",
        },
        {
          imageStr: "mp",
          titleStr: "电子名片",
          url: "http://www.99mingpian.cn",
        },
        {
          imageStr: "dc",
          titleStr: "问卷调查",
          url: "https://www.wjguanjia.com",
        },
        {
          imageStr: "cp",
          titleStr: "考试测评",
          url: "https://www.wjguanjia.com",
        },
      ],

      tableData: [
        {
          name: "学生常用模板",
          array: [],
        },
        {
          name: "老师常用模板",
          array: [],
        },
        {
          name: "职场办公模板",
          array: [],
        },
        {
          name: "考勤签到模板",
          array: [],
        },
      ],
    };
  },
  created() {
    //如果没登录跳转登录页
    if (!localStorage.getItem("token")) {
      this.$router.replace("/login");
    }

    // 报名管家/报名管家vip：收费报名入口改为预约（图标 yyxm.svg）
    if (this.isButler) {
      const sfbmItem = this.clickItems.find((i) => i.titleStr === "收费报名");
      if (sfbmItem) {
        sfbmItem.titleStr = "预约";
        sfbmItem.imageStr = "yyxm.svg";
      }
    }

    this.getMessage();
  },
  mounted() {
    // 确保标题设置生效
    this.$nextTick(() => {
      this.setPageTitle();
    });
  },
  computed: {
    emptyDivs() {
      return this.tableData.map((item) => {
        const remainder = item.array.length % 3;
        return remainder === 0 ? 0 : 3 - remainder;
      });
    },
  },
  methods: {
    // 设置页面标题
    setPageTitle() {
      // 根据 AppID 确定后缀
      let suffix = '接龙加加';
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = '报名管家';
      }

      document.title = `发布接龙 - ${suffix}`;
      console.log(document.title, "document.title");
    },
    goOtherWeb(item) {
      if (item.url) {
        window.open(item.url, "_blank");
      }
    },

    // 新标签页打开路由
    openInNewTab(route) {
      const routeData = this.$router.resolve(route);
      window.open(routeData.href, "_blank");
    },

    // async getMessage() {
    //   // 通用接龙
    //   await getHomePageTempleList({
    //     templateIndex: 3,
    //     pageNum: 1,
    //   }).then((res) => {
    //     console.log(res, "请求列表数据");
    //     if (res.status == 1) {
    //       this.tableData[0].array = res.data.list;
    //     }
    //   });

    //   // 签到打卡
    //   await getHomePageTempleList({
    //     templateIndex: 4,
    //     pageNum: 1,
    //   }).then((res) => {
    //     console.log(res, "请求列表数据");
    //     if (res.status == 1) {
    //       this.tableData[1].array = res.data.list;
    //     }
    //   });
    // },
    async getMessage() {
      // 学生常用模板
      await getHomePageTempleList({
        templateIndex: 6,
        pageNum: 1,
        pageSize: 20,
        homepageTemplateTypes: "1",
      }).then((res) => {
        console.log(res, "请求列表数据-学生常用模板");
        if (res.status == 1) {
          this.tableData[0].array = res.data.list.reverse();
        }
      });

      // 签到打卡
      await getHomePageTempleList({
        templateIndex: 6,
        pageNum: 1,
        pageSize: 20,
        homepageTemplateTypes: "2",
      }).then((res) => {
        console.log(res, "请求列表数据-老师常用模板");
        if (res.status == 1) {
          this.tableData[1].array = res.data.list.reverse();
        }
      });
      await getHomePageTempleList({
        templateIndex: 6,
        pageNum: 1,
        pageSize: 20,
        homepageTemplateTypes: "3",
      }).then((res) => {
        console.log(res, "请求列表数据-职场办公模板");
        if (res.status == 1) {
          this.tableData[2].array = res.data.list.reverse();
        }
      });
      await getHomePageTempleList({
        templateIndex: 6,
        pageNum: 1,
        pageSize: 20,
        homepageTemplateTypes: "4",
      }).then((res) => {
        console.log(res, "请求列表数据-考勤签到模板");
        if (res.status == 1) {
          this.tableData[3].array = res.data.list.reverse();
        }
      });
    },

    // 跳转到搜索列表页
    goSearch(typeStr) {
      console.log(typeStr);
      switch (typeStr) {
        case "通用接龙":
          this.openInNewTab({
            path: "/stencilSearch",
            query: { templateIndex: 3, isType: 106 },
          });
          break;
        case "签到打卡":
          this.openInNewTab({
            path: "/stencilSearch",
            query: { templateIndex: 4, isType: 109 },
          });
          break;
        case "活动报名":
          this.openInNewTab({
            path: "/stencilSearch",
            query: { templateIndex: 1, classifyName: "活动报名", isType: 106 },
          });
          break;
        case "收费报名":
          this.openInNewTab({
            path: "/stencilSearch",
            query: { templateIndex: 1, classifyName: "收费报名", isType: 101 },
          });
          break;
        case "预约":
          this.openInNewTab({
            path: "/stencilSearch",
            query: { templateIndex: 8, classifyName: "预约", isType: 106 },
          });
          break;
        case "打卡接龙":
          this.openInNewTab({
            path: "/stencilSearch",
            query: { templateIndex: 1, classifyName: "打卡", isType: 109 },
          });
          break;
        case "签到接龙":
          this.openInNewTab({
            path: "/stencilSearch",
            query: { templateIndex: 1, classifyName: "签到", isType: 109 },
          });
          break;
        case "信息收集":
          this.openInNewTab({
            path: "/stencilSearch",
            query: { templateIndex: 2, isType: 106 },
          });
          break;

        default:
          break;
      }
    },

    // 查看更多
    lookMareClick() {
      this.openInNewTab({
        path: "/modelList",
      });
    },

    // 进入创建页面
    creatClick(item) {
      console.log(item, "item");
      if (item.activity_big_type == 2) {
        this.openInNewTab({
          path: "/groupNotification",
          query: { alias: item.activity_key, selectType: "add", isType: 201 },
        });
      }
      if (item.activity_type == 109) {
        this.openInNewTab({
          path: "/solitaire",
          query: { alias: item.activity_key, selectType: "add", isType: 109 },
        });
      }
      if (item.activity_type == 110) {
        this.openInNewTab({
          path: "/solitaire",
          query: { alias: item.activity_key, selectType: "add", isType: 110 },
        });
      }
      if (item.activity_type == 106) {
        this.openInNewTab({
          path: "/solitaire",
          query: { alias: item.activity_key, selectType: "add", isType: 106 },
        });
      }
      if (item.activity_type == 105) {
        this.openInNewTab({
          path: "/solitaire",
          query: { alias: item.activity_key, selectType: "add", isType: 105 },
        });
      }
      if (item.activity_type == 104) {
        this.openInNewTab({
          path: "/solitaire",
          query: { alias: item.activity_key, selectType: "add", isType: 104 },
        });
      }
      //
      // console.log(item,'item');
      // this.openInNewTab({
      //   path: "/solitaire",
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.base-class {
  display: flex;
  width: 1100px;
  justify-content: space-between;
  //transform: scale(0.9); /* 缩小页面至90% */
  //transform-origin: top left; /* 确保缩放从左上角开始 */
}
.top-item {
  cursor: pointer;
  width: 360px;
  height: 85px;
  margin-right: 15px;
  cursor: pointer;
  background: linear-gradient(to right, #3A41EF , #888CF7);
  border-radius: 3px;
  &:last-child {
    margin-right: 0; // 移除最后一项的外边距
  }
}
.top-image {
  width: 360px;
  height: 85px;
  position: absolute;
  z-index: -1;
}
.top-title {
  color: #ffffff;
  line-height: 35px;
  font-size: 20px;
  font-weight: 600;
  margin-left: 15px;
  margin-top: 12px;
  margin-bottom: 5px;
}

.top-count {
  color: #ffffff;
  line-height: 22px;
  font-size: 14px;
  font-weight: 200;
  margin-bottom: 13px;
}
.creat-text {
  color: #ffffff;
  line-height: 22px;
  text-align: right;
  font-size: 14px;
  margin-right: 15px;
  font-weight: 600;
}

.click-item {
  cursor: pointer;
  width: 235px;
  height: 80px;
  margin-right: 12px;
  background-color: #ffffff;
  margin-top: 10px;
  border-radius: 3px;
  display: flex;
  cursor: pointer;
  font-weight: 600;
  padding: 0 15px;
  justify-content: space-between;
  &:last-child {
    margin-right: 0; // 移除最后一项的外边距
  }
  &:hover .click-title {
    color: #1877ff; /* 鼠标悬浮时的字体颜色 */
  }
}
.click-image {
  width: 60px;
  height: 60px;
  margin-top: 10px;
}

.click-title {
  font-size: 16px;
  color: #2b2f36;
  line-height: 28px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.click-creat {
  color: #a2a2a2;
  line-height: 20px;
  font-size: 13px;
  font-weight: 400;
}

.model-top {
  justify-content: space-between;
  display: flex;
  width: 1100px;
  margin-top: 20px;
}
.model-top-title {
  color: #2b2f36;
  line-height: 21px;
  font-size: 17px;
  font-weight: 600;
}
.model-top-more {
  color: #686868;
  line-height: 19px;
  font-size: 14px;
}
.model-item {
  width: 355px;
  height: 80px;
  background-color: #ffffff;
  border-radius: 4px;
  display: flex;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  align-items: center;
  // justify-content: space-around;
  &:nth-child(3n) {
    margin-right: 0; // 移除每一排中第三个元素的外边距
  }
  &:hover .model-item-title {
    color: #1877ff; /* 鼠标悬浮时的字体颜色 */
  }
}
.emptyDiv {
  width: 355px;
  height: 80px;
  opacity: 0;
}

.model-item-title {
  color: #2a2b3c;
  line-height: 22px;
  font-size: 16px;
  margin-top: 18px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.model-item-count {
  color: #a3a7ad;
  line-height: 20px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.free-button {
  cursor: pointer;
  width: 80px;
  height: 31px;
  background-color: #1877ff;
  border-radius: 18px;
  text-align: center;
  line-height: 31px;
  color: #ffffff;
  font-size: 13px;
  margin-top: 30px;
  margin-left: 10px;
}
</style>
